const es = {
  "nav.search": "Buscar...",
  "nav.moreOptions": "Más opciones",
  "nav.hide": "Ocultar",
  "nav.show": "Mostrar",
  "nav.logout": "Salir",
  "nav.language": "Idioma",
  "nav.dashboard": "Dashboard",
  "nav.inbox": "Conversaciones",
  "nav.crm": "CRM",
  "nav.agenda": "Agenda",
  "nav.business": "Mi Negocio",
  "nav.admin": "Administración",
  "nav.email": "Email",
  "nav.whatsapp": "WhatsApp",
  "nav.marketing": "Marketing",
  "nav.plan": "Mi Plan",
  "nav.integrations": "Integraciones",
  "nav.setup": "Atención automática",
  "nav.ai": "Config IA",
  "nav.reports": "Reportes",
  "nav.social": "Social & Ads",
  "nav.web": "Sitio Web",
  "mkt.title": "Marketing",
  "mkt.sub": "Captación y crecimiento. Los envíos masivos de correo y WhatsApp están en el menú lateral.",
  "mkt.home": "Inicio",
  "mkt.origins": "Orígenes de leads",
  "mkt.lists": "Listas",
  "mkt.automations": "Secuencias",
  "mkt.more": "Más",
  "mkt.campaigns": "Campañas (avanzado)",
  "mkt.contacts": "Contactos",
  "mkt.schedules": "Calendario envíos",
  "mkt.delivery": "Pruebas de envío",
  "mkt.whatToday": "¿Qué quieres hacer hoy?",
  "mkt.whatTodaySub": "Captación (orígenes, listas) y el mapa de automatizaciones. Envíos masivos: menú Email o WhatsApp.",
  "mkt.originsTitle": "Orígenes de leads",
  "mkt.originsSub": "WhatsApp por frase, QR, portales, web…",
  "mkt.originsP1": "Crea un QR con mensaje de arranque",
  "mkt.originsP2": "El lead escribe y entra a tu flujo / IA",
  "mkt.originsP3": "Descarga e imprime en segundos",
  "mkt.originsCta": "Configurar orígenes",
  "mkt.audienceTitle": "Listas y audiencias",
  "mkt.audienceSub": "A quién le hablas en cada envío",
  "mkt.audienceP1": "Landing o formulario conectado al CRM",
  "mkt.audienceP2": "Dispara flows y asignación",
  "mkt.audienceP3": "Ideal para campañas digitales",
  "mkt.audienceCta": "Ver orígenes",
  "mkt.segmentsTitle": "Listas / segmentos",
  "mkt.segmentsText": "A quién le mandas (cumpleaños, etapa CRM, fechas…)",
  "mkt.autoTitle": "Automatizaciones del negocio",
  "mkt.nurtureHint": "Tres herramientas claras: secuencias, ruta del lead y reglas al instante.",
  "mkt.autoText": "Secuencias (tiempo), Ruta del lead (al entrar) y Reglas al instante (un aviso).",
  "mkt.massSection": "Envíos masivos (módulos separados)",
  "mkt.emailMass": "Email masivo",
  "mkt.emailMassSub": "Mailing SES · plantillas · informes",
  "mkt.waMass": "WhatsApp masivo",
  "mkt.waMassSub": "Plantillas Meta · envíos · conexión API",
  "mkt.statLeads": "Leads",
  "mkt.statTpl": "Plantillas WA",
  "mkt.statDrafts": "Campañas borrador",
  "mkt.statAuto": "Automáticos activos",
  "email.home": "Inicio",
  "email.new": "Nuevo envío",
  "email.history": "Historial",
  "email.templates": "Plantillas",
  "email.domain": "Mi dominio",
  "email.reports": "Informes",
  "email.title": "Email",
  "email.sub": "Envíos masivos de correo con tu marca",
  "wa.home": "Inicio",
  "wa.connection": "Conexión",
  "wa.sends": "Envíos",
  "wa.templates": "Plantillas",
  "wa.reports": "Informes",
  "wa.title": "WhatsApp",
  "wa.sub": "Envíos masivos y conexión Business API",
  "crm.pipeline": "Pipeline",
  "crm.leads": "Leads",
  "crm.tasks": "Tareas",
  "crm.templates": "Plantillas",
  "inbox.all": "Todas",
  "inbox.open": "Abiertas",
  "inbox.closed": "Cerradas",
  "agenda.calendar": "Calendario",
  "agenda.resources": "Servicios y recursos",
  "agenda.tables": "Mapa de mesas",
  "biz.summary": "Mi negocio",
  "biz.team": "Mi equipo",
  "biz.assignment": "Asignación",
  "biz.flows": "Ruta del lead",
  "biz.profile": "Perfil y horario",
  "biz.locations": "Sucursales",
  "rep.status": "Estado",
  "rep.detail": "Detalle técnico",
  "common.loading": "Cargando…",
  "common.cancel": "Cancelar",
  "common.save": "Guardar",
  "common.next": "Siguiente",
  "common.back": "Atrás",
  "common.edit": "Editar",
  "common.delete": "Eliminar",
  "common.create": "Crear",
  "common.view": "Ver",
  "common.close": "Cerrar",
  "common.copy": "Copiar",
  "common.search": "Buscar",
  "common.active": "Activo",
  "common.inactive": "Inactivo",
  "origins.title": "Orígenes de leads",
  "origins.sub": "Un origen = medio + cómo llega + campaña. WhatsApp, llamada, webhook o correo inteligente.",
  "origins.create": "Crear origen",
  "origins.edit": "Editar",
  "origins.connection": "Datos de conexión",
  "origins.webhook": "Webhook",
  "origins.email": "Correo inteligente",
  "origins.secret": "Secret",
  "origins.secretOnce": "Secret (cópialo ahora; no se vuelve a mostrar completo)",
  "origins.regen": "Regenerar secret",
  "origins.copy": "Copiar",
  "origins.free": "Mensajes libres de WhatsApp",
  "origins.freeHelp": "Siempre activa. Chats sin frase de campaña o si borran el texto del anuncio.",
  "origins.empty": "Aún no hay orígenes",
  "origins.leads": "leads",
  "origins.save": "Guardar cambios",
  "origins.close": "Cerrar",
  "origins.howTo": "Cómo conectar",
  "lang.es": "Español",
  "lang.en": "English",
  "lang.de": "Deutsch",
  "lang.pt": "Português",
  "lang.choose": "Idioma",
  "lang.auto": "Automático (por región)",
  "login.title": "Inicia sesión",
  "login.subtitle": "Accede a tu negocio",
  "login.email": "Correo",
  "login.password": "Contraseña",
  "login.name": "Nombre",
  "login.submit": "Entrar",
  "login.register": "Crear cuenta",
  "login.haveAccount": "¿Ya tienes cuenta? Inicia sesión",
  "login.noAccount": "¿No tienes cuenta? Regístrate",
  "login.forgot": "¿Olvidaste tu contraseña?",
  "login.mfa": "Verificación en dos pasos",
  "login.mfaHint": "Ingresa el código de 6 dígitos de tu app de autenticación, o uno de tus códigos de respaldo.",
  "login.code": "Código",
  "login.inactive": "Tu sesión terminó después de 60 minutos sin actividad.",
  "login.titleRegister": "Crear cuenta",
  "login.titleLogin": "Iniciar sesión",
  "login.emailLabel": "Correo electrónico",
  "login.passwordLabel": "Contraseña",
  "login.nameLabel": "Nombre completo",
  "login.submitLogin": "Iniciar sesión",
  "login.submitRegister": "Crear cuenta",
  "login.switchToLogin": "¿Ya tienes cuenta? Inicia sesión",
  "login.switchToRegister": "¿No tienes cuenta? Regístrate",
  "login.heroTitle": "Tu negocio, automatizado",
  "login.heroSub": "Atención, ventas y seguimiento en un solo lugar.",
  "login.verify": "Verificar",
  "dash.welcome": "Bienvenido",
  "dash.overview": "Resumen de tu negocio",
  "admin.pos": "Punto de venta",
  "admin.warranty": "Mesa de Servicio",
  "admin.condo": "Gestión condominal",
  "admin.sub": "Operación del negocio: punto de venta y caja",
  "filtros.from": "Desde",
  "filtros.to": "Hasta",
  "filtros.seller": "Vendedor",
  "filtros.group": "Grupo",
  "filtros.campaign": "Campaña",
  "filtros.clear": "Quitar filtros",
  "common.all": "Todos",
  "common.all_f": "Todas",
};
export default es;
